export const subscriptionTypeConversion = value => {
  let type
  switch (value) {
    case 100:
      type = 'MONTHLY'
      break
    case 200:
      type = 'YEARLY'
      break
    default:
      type = 'MONTHLY'
  }
  return type
}

export const typeIcon = value => {
  let type
  switch (value) {
    case 'FREE':
      type = 'fa fa-lock'
      break
    case 100:
      type = 'fa fa-lock'
      break
    case 'PRO':
      type = 'fa fa-rss-square'
      break
    case 200:
      type = 'fa fa-rss-square'
      break
    case 'TEAM':
      type = 'fa fa-users'
      break
    case 300:
      type = 'fa fa-users'
      break
    default:
      type = ''
  }
  return type
}



// WEBPACK FOOTER //
// ./src/utils/subscriptionType.js